import TabPage from "../../factories/tab-page";
import "../../bindings/bao-toolbar2";
import SubscriptionViewModel from "../../factories/subscription-view-model";
import BaoDialog from "../../factories/bao-dialog";
import * as ko from "knockout";
import Bao from "../../services/bao-service";
import baoRouter from "../../services/bao-router";

/**
    * WorkItemChecklist Tab class
*/
class WorkItemChecklistTab extends SubscriptionViewModel {

    //#region Constructors

    constructor(tabPage: TabPage, parent: any) {
        super(tabPage);
        this.WorkItemId(parent.WorkItemId())
        this.ParentWorkItemId(parent.PrimaryWorkItemId())
        this.SessionTabId(parent.TabPage.SessionTabId);

        this.TabPage = tabPage;
        this.ReportViewModel = parent;
     
        this.PageIndex.subscribe(() => {
            this.RefreshGrid();
        });
        this.Sorting.subscribe(() => {
            this.RefreshGrid();
        });

        this.SelectedEvaluationRow.subscribe(() => {
            if (this.SelectedEvaluationRow()) {
                if (this.enableButton != undefined) {
                    this.enableButton("WorkItemChecklistTabEdit", true);
                    this.enableButton("WorkItemChecklistTabRemove", true);
                }
            }
            else {              
                if (this.enableButton != undefined) {
                    this.enableButton("WorkItemChecklistTabEdit", false);
                    this.enableButton("WorkItemChecklistTabRemove", false);
                }
            }
        });

        if (parent.IsBasedOnVirtual()) {
            this.InitBasedOnSerialTask(true);
        }
        
        Bao.bindEvent('checklist-evaluation:refresh', () => {
            this.Refresh(); 
        })
    }
    
    //#endregion

    //#region Properties

    WorkItem: any;
    TabPage: any;
    Bao = Bao;
    ReportViewModel;
    OriginalTabTitle: string = "";
    CompleteCheck = () => {
        return true;
    };
    WorkItemId = ko.observable("");
    SessionTabId = ko.observable("");
    PageIndex = ko.observable(0);
    PageSize = ko.observable(10);
    TotalRows = ko.observable(0);
    Sorting = ko.observableArray();
    Columns = ko.observableArray([]);
    EvaluationCollection = ko.observableArray([]);
    SelectRow = (item) => {
        this.SelectedEvaluationRow(item);
        return true;
    };
    SelectedEvaluationRow = ko.observable<any>({});
    enableButton: (actionpKey: string, enabled: boolean) => void;

    /**
     * Store the info if the WorkItem is a WorkItem Series 
     */
    InitBasedOnSerialTask: KnockoutObservable<boolean> = ko.observable(false);

    /**
     * Parent WorkItemId (the "parent" for series elements)
     */
    ParentWorkItemId: KnockoutObservable<boolean> = ko.observable(false);

    //#endregion

    //#region Public Methods

    /**
     * Method used to handle buttons
     */
    toolbarClick = (action) => {
        switch (action.ActionKey()) {
            case "WorkItemChecklistTabAdd":
                this.ShowCreateEvaluationDialog(this.WorkItemId());
                break;  
            case "WorkItemChecklistTabEdit":
                if (this.SelectedEvaluationRow() != null) {
                    this.EditReportEvaluation(this.SelectedEvaluationRow());
                }
                break;
            case "WorkItemChecklistTabRemove":
                var yesNoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgDeleteReportEvaluation"), "yesno");
                yesNoDialog.DialogResult.subscribe((result) => {
                    if (result === true) {
                        this.RemoveReportEvaluation(this.SelectedEvaluationRow());
                    }
                });
                break;
            case "WorkItemChecklistTabRefresh":
                this.RefreshGrid();
                break;
        }
    };

    /**
     * Method used to fetch data from the server
     */
    RefreshGrid = () => {
        this.TabPage.IsLoading(true);
        return Bao.post("WorkItemChecklistTab/Get", JSON.stringify({
            customFilter: this.CustomFilter(),
            sessionTabId: this.SessionTabId(),
            parentId: this.WorkItemId(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.GetCustomSort(this.Sorting())
        }), (searchResult) => {
            this.TabPage.IsLoading(false);
            this.SelectedEvaluationRow(null);
            this.TotalRows(0);
            this.EvaluationCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                this.EvaluationCollection(searchResult.Models);
                this.TotalRows(searchResult.TotalRows);
            }
            this.TabPage.Title(this.OriginalTabTitle + " (" + this.TotalRows() + ")");
        });
    };
    
    /**
     * Method used to fetch data from the server
     */
    RemoveReportEvaluation = (item) => {      
        let ids = [item.WorkItemChecklistId];
        Bao.post("WorkItemChecklistTab/Remove", JSON.stringify({
            ids: ids,
            sessionTabId: this.SessionTabId()
        }), () => {
            this.RefreshGrid();            
            this.ReportViewModel.TabPage.DirtyFlag(true)
            this.TabPage.DirtyFlag(true);
        });
    };

    /**
     * Method used to edit WorkItemChecklist entity
     */
    EditReportEvaluation = (item) => {
        baoRouter.setHash("checkware/evaluation/" + ko.unwrap(item.EvaluationId));
    };

    /**
     * Method used to commit changes made to WorkItemChecklist list
     */
    Commit(saveTime: string): JQueryPromise<void> {
        this.TabPage.IsLoading(true);
        return Bao.post("WorkItemChecklistTab/Commit", JSON.stringify({
            sessionTabId: this.SessionTabId(),
            version: saveTime
        }), () => {
            this.TabPage.DirtyFlag.reset();
        }).always(() => {
            this.TabPage.IsLoading(false);
        });
    }

    /**
     * Method used to create an evaluation using workItemId and sessionId
     */
    CreateEvaluation = function (folderStructureChecklistId, workItemId) {
        return Bao.post("WorkItemChecklistTab/CreateEvaluationByWorkItemId", JSON.stringify({
            folderStructureChecklistId: folderStructureChecklistId,
            workItemId: workItemId,
            sessionTabId: this.SessionTabId()
        }), function (result) {
            if (result) {
                baoRouter.setHash("checkware/evaluation/" + result);
            }
        });
    };

    /**
     * Method used to show create evaluation dialog
     */
    ShowCreateEvaluationDialog = (workItemId) => {
        window.baorequire(['ViewModels/Dialogs/CreateEvaluationDialog'], (vm) => {
            let dialog = new vm(this.TabPage, null);
            dialog.Show();
            dialog.DialogResult.subscribe((dialogResult) => {
                if (dialogResult) {
                   this.CreateEvaluation(dialog.DialogViewModel.FolderStructureChecklistId(), workItemId);
                }
            });
        });
    };

    /**
     * Method used to refresh a view
     */
    Refresh = () => {
        return this.RefreshGrid();
    };
    
    /**
     * Method used to load columns
     */
    loaded = () => {
        return Bao.post('EvaluationTab/LoadColumns', JSON.stringify({
            shiftbookTabId: this.TabPage.ObjectId(),
        }), (result) => {
            this.Columns([]);
            if (result !== false) {
                result.forEach(column => {
                    column.PropertyName = "Evaluation" + column.PropertyName;
                });

                this.Columns(result);
            }
        })
            .then(_ => this.Refresh())
            .then(() => {
                return this.subscribe(this.PageSize, () => {
                    if (this.PageIndex() === 0) {
                        return this.RefreshGrid();
                    }
                    else {
                        return this.PageIndex(0);
                    }
                });
            });
    };

    /**
     * Init
     */
    init = () => {
        this.OriginalTabTitle = this.TabPage.Title();
    }

    //#endregion    

    //#region Protected Methods

    /**
     * Returns custom filters
     * @returns Custom filters
     */
    protected CustomFilter(): Models.HashObject[] {
        let customFilterHashObject: Models.HashObject[] = [];
        if (this.InitBasedOnSerialTask()) {
            customFilterHashObject.push({
                Key: 'WorkItemId',
                Value: this.ParentWorkItemId()
            });
            customFilterHashObject.push({
                Key: 'BaseOnSerialTask',
                Value: true
            });
        }
        return customFilterHashObject;
    }

    /**
     * Method to sort list by "datetime" property
     */
    protected GetCustomSort(sorting: any) {
        let customSort = []
        sorting.forEach(element => {
            if (element.Column === "EvaluationEvaluationDateJs"){
                customSort.push({Column: "EvaluationEvaluationDate", Direction: element.Direction });
            }
            else if (element.Column === "EvaluationCompleteDateJs"){
                customSort.push({Column: "EvaluationEvaluationDate", Direction: element.Direction });
            }    
            else {
                customSort.push({Column: element.Column, Direction: element.Direction });
            }         
        });
        return customSort;
    }

    //#endregion

}
export default WorkItemChecklistTab;